import { ExpandableText, Grid } from 'portal-commons';
import React, { FC } from 'react';
import { TableRow, TableCell } from '@material-ui/core';

import { CroppableItem } from '@/components';
import { convertTimeWithTimezone } from '@/utils/time';
import { humanizeAuthenticatedUser } from '@/utils/string';

interface EventTableRowProps {
  data: {
    description: string;
    authenticatedUser: string | null;
    createDate: number;
  };
}

const EventTableRow: FC<EventTableRowProps> = ({ data }) => {
  const createDate = convertTimeWithTimezone(data.createDate);
  const authenticatedUser = humanizeAuthenticatedUser(data.authenticatedUser);

  return (
    <TableRow>
      <TableCell
        style={{ maxWidth: 160 }}
        data-testid="eventListingTableCreateDate"
      >
        <CroppableItem title={createDate}>{createDate}</CroppableItem>
      </TableCell>
      <TableCell
        style={{
          maxWidth: 130,
        }}
        data-testid="eventListingTableAuthenticatedUser"
      >
        <CroppableItem title={authenticatedUser}>
          {authenticatedUser}
        </CroppableItem>
      </TableCell>
      <TableCell data-testid="eventListingTableDescription">
        <Grid
          sx={{
            gridTemplateColumns: 'minmax(200px, 1fr)',
            width: '100%',
          }}
        >
          <ExpandableText text={data.description} maxWidth="100%" />
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default EventTableRow;
